// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { currency, generateId, mobileView } from './api/utility';
import Cart, { itemTypes } from './Cart';
import Button from './form/Button';
import Icon from './form/Icon';
import ImageCard from '../_pwa/ImageCard';
import { useGlobalState } from './globalState/GlobalStateProvider';

const ColorWrap = styled.div`
    position: relative;
    background-color: ${({ theme }) => theme.error};
    transition: max-height 0.2s;
    max-height: 200px;
    overflow: hidden;

    ${({ removed }) => removed ? `
        max-height: 0;
    ` : null}
`

const Wrapper = styled.div`
    position: relative;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;

    padding: 0.5em 1em;
    background-color: ${({ theme, mobile }) => mobile ? theme.mobile.background : theme.body};
    border-top: 1px solid ${({ theme, mobile }) => mobile ? theme.mobile.secondary : theme.secondary};

    font-size: 0.9em;
    
    ${({ dragging }) => !dragging ? 'transition: all 0.2s;' : null}
`
const ButtonWrap = styled.div`
    display: flex;
    align-items: center;
`
const Row = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
`
const IconButton = styled(Button)`
    position: relative;
    width: 1em;
    background: ${({ theme, mobile }) => mobile ? theme.mobile.secondary : theme.secondary};
`
const I = styled(Icon)`
    position: absolute;
    top: 50%;
    left: 15%;
    transform: translate3d(-50%, -50%, 0);
`
const Image = styled(ImageCard)`
    height: 100%;
    width: 100%;
    border-radius: 1rem;
    overflow: hidden;
`
const SmallerText = styled.div`
    font-size: 0.8em;
`

const CheckoutCard = ({ title, price, color, image, details, item, ...props }) => {

    const { state: {
        // mobileView
    } } = useGlobalState();

    const [showTrash, setShowTrash] = useState(false);
    const [dragging, setDragging] = useState(false);
    const [removed, setRemoved] = useState(false);

    const id = generateId();

    useEffect(() => {
        dragElement(document.getElementById(id))

        function dragElement(elmnt) {
            var posX1 = 0, posY1 = 0, posX2 = 0, posY2 = 0;
            elmnt.ontouchstart = dragMouseDown;

            function dragMouseDown(e) {
                e = e || window.event;
                posX1 = e.changedTouches[0].clientX;
                posY1 = e.changedTouches[0].clientY;

                setDragging(true)
                document.ontouchend = closeDragElement;
                document.ontouchmove = elementDrag;
            }

            function elementDrag(e) {
                e = e || window.event;

                posX2 = e.changedTouches[0].clientX;
                posY2 = e.changedTouches[0].clientY

                let newPos = (posX2 - posX1)

                newPos = (newPos > 20 ? newPos : 0)

                setShowTrash(posX2 - posX1 > (window.screen.width * 0.5))

                elmnt.style.left = newPos + "px";
            }

            function closeDragElement() {
                document.ontouchend = null;
                document.ontouchmove = null;
                setDragging(false)

                if (posX2 - posX1 > (window.screen.width * 0.5)) {
                    removeCard()
                } else {
                    resetBody();
                }
            }

            function resetBody() {
                elmnt.style.left = '0px'
            }

            function removeCard() {
                elmnt.style.left = '110%'
                setRemoved(true)
                setTimeout(() => {
                    if (item.isGift) {
                        Cart.Remove(item)
                    } else {
                        Cart.RemoveAll(item)
                    }
                }, 200)
            }
        }
    }, [])

    return (
        <ColorWrap
            removed={removed}
        >
            {showTrash ? <I icon='trash' /> : null}
            <Wrapper
                item={item}
                id={id}
                dragging={dragging}
                data-draggable={dragging}
                mobile={mobileView}
            >
                <Row item={item} parentId={id}>
                    <Col>
                        <b>{item.name}</b>
                        <div>
                            {Cart.GetItemPrices(item)}
                        </div>
                        {item.taxes ? <SmallerText>Tax: {currency.format(item.taxes * Cart.GetNonGiftItemTotal(item))}</SmallerText> : null}

                        {item.isGift ? <SmallerText>{item.giftedEmail}</SmallerText> : null}
                    </Col>

                    <ButtonWrap>
                        {
                            item.isGift ?
                                <>
                                    <IconButton mobile={mobileView} onClick={() => Cart.Remove(item)} icon={'trash'} />
                                    <div style={{ width: '1.5em', textAlign: 'center' }}>1</div>
                                </> :
                                <>
                                    <IconButton onClick={() => Cart.Remove(item)} icon={Cart.GetNonGiftItemTotal(item) > 1 ? 'minus' : 'trash'} />
                                    <div style={{ width: '1.5em', textAlign: 'center' }}>{Cart.GetNonGiftItemTotal(item)}</div>
                                    <IconButton onClick={() => Cart.Add(item)} icon='plus' style={{ visibility: item.productType === itemTypes.washClub ? 'hidden' : '' }} />
                                </>
                        }
                    </ButtonWrap>
                </Row>
            </Wrapper>
        </ColorWrap>

    );
}

export default CheckoutCard;